export function isUrlExternal(href) {
    try {
        const validUrl = new URL(href);
        return !validUrl.host.includes('fandom.com');
    }
    catch (_a) {
        return true;
    }
}
